import type { ContextSessionResponse } from "@kontextwerk/control-web-client"
import {
    evaluateCapabilities,
    type OperationRequirements,
} from "@kontextwerk/control-web-frame/shared/logic/authorization"
import { KEHRBLATT_CONTEXT_CATALOG } from "../../../../_shared/_logic/context-capabilities"

export const membershipSettingsRequirements = (
  operation: "list" | "read" | "update",
): OperationRequirements => ({
  operation: `kehrblatt.membership_settings.${operation}`,
  any_of: [
    [
      { key: "core.memberships", level: operation === "update" ? "manage" : "view" },
      { key: "kehrblatt.scheduling", level: operation === "update" ? "manage" : "view" },
    ],
  ],
})
export const admitsMembershipSettings = (
  session: ContextSessionResponse | null,
  operation: "list" | "read" | "update",
  membershipId?: string,
) => {
  if (
    !session ||
    session.product_issuer !== "kehrblatt-control" ||
    session.password_change_required ||
    session.context.kind !== "organization"
  )
    return false

  if (
    session.context.delegation &&
    !(Date.parse(session.context.delegation.expires_at) > Date.now())
  )
    return false

  const decision = evaluateCapabilities(
    session,
    KEHRBLATT_CONTEXT_CATALOG,
    membershipSettingsRequirements(operation),
  )

  if (!decision.allowed) return false

  if (!membershipId) return true

  return decision.alternatives[0].some(
    (grant) =>
      grant.key === "core.memberships" ||
      grant.scope === "all" ||
      (grant.scope === "own" &&
        session.context.kind === "organization" &&
        membershipId === session.context.membership_id),
  )
}
